export default __webpack_public_path__ + "assets/images/3dc5894f7085aecacf5b632fa6f71187.png";